<div>
  <!-- System Notifications -->
  <div class="notifications-container mb-4" *ngIf="!loadingNotifications && notifications.length > 0">
    <div 
      *ngFor="let notification of notifications" 
      class="alert d-flex align-items-start" 
      [ngClass]="[getAlertClass(notification.type), isHighPriority(notification.priority) ? 'alert-high-priority' : '']"
      role="alert">
      <i class="bi me-3 fs-5 d-flex align-items-center" [ngClass]="getIconClass(notification.type)"></i>
      <div class="flex-grow-1">
        <h5 class="alert-heading mb-2">{{ notification.title }}</h5>
        <p class="mb-0" [innerHTML]="notification.message"></p>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div class="notifications-container mb-4" *ngIf="loadingNotifications" data-cy="loading-message">
    <div class="alert alert-info" role="alert">
      <div class="d-flex align-items-center">
        <div class="spinner-border spinner-border-sm me-2" role="status">
          <span class="visually-hidden">Loading notifications...</span>
        </div>
        <span>Loading system notifications...</span>
      </div>
    </div>
  </div>

  <div class="alert alert-warning mt-3" role="alert" data-cy="title">
    <h4 class="alert-heading">VPN Connection Required</h4>
    <p>
      To use the CCS application, please connect to AU's VPN first.
    </p>
    <hr />
    <p class="mb-0">
      Need help setting up the VPN or logging in? Contact the IT Help Desk.
    </p>
  </div>

  <h2 class="welcome" data-cy="welcome-message">Welcome to the Course Config System!</h2>
  <p>
    <strong>Important Notice: Internal Use Only </strong>
  </p>
  <p>
    This software application is exclusively intended for use by employees and
    authorized personnel of Athabasca University. Access to and use of this
    application is restricted to individuals with valid credentials and
    authorization. Any unauthorized access or use of this software is strictly
    prohibited and may result in disciplinary or legal action.
  </p>
  <p>
    By using this application, you agree to abide by the organization's policies
    and guidelines for information technology usage. All data and information
    processed or stored within this application must comply with security and
    data privacy policies.
  </p>
  <p>
    Thank you for your cooperation in maintaining the security and
    confidentiality of our organization's resources.
  </p>
</div>
